import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { GraduationCap, Play, Sparkles, Copy, Languages, FileText, Mic } from "lucide-react";

export default function LearningPage() {
  const [courses, setCourses] = useState([]);
  const [prompts, setPrompts] = useState([]);
  useEffect(() => {
    api.get("/learning/courses").then((r)=>setCourses(r.data.items));
    api.get("/learning/prompts").then((r)=>setPrompts(r.data.items));
  }, []);
  const tools = [
    { icon: FileText, title: "Document Summarizer", desc: "Turn long circulars into key bullet points." },
    { icon: Sparkles, title: "Meeting Minutes Generator", desc: "From notes to formal minutes in seconds." },
    { icon: Languages, title: "Translate → Punjabi", desc: "English to Gurmukhi with government tone." },
    { icon: Mic,      title: "Speech to Text",         desc: "Transcribe field recordings and dictations." },
  ];
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">AI Capacity Building</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">AI Learning Portal</h1>
        <p className="text-sm text-muted-foreground mt-1">Upskill your team with curated AI courses and ready-to-use prompts.</p>
      </div>

      <div>
        <div className="label-tiny mb-3">Featured Courses</div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {courses.map(c => (
            <div key={c.id} className="rounded-xl border border-border bg-card p-5">
              <div className="flex items-start justify-between">
                <div className="h-10 w-10 rounded-lg bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><GraduationCap className="h-5 w-5"/></div>
                <span className="stat-pill bg-muted text-muted-foreground text-[10px] uppercase">{c.level}</span>
              </div>
              <div className="mt-3 font-heading font-semibold">{c.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{c.category}</div>
              <div className="mt-3 flex items-center justify-between text-xs">
                <span>{c.modules} modules · {c.duration}</span>
                <span className="text-muted-foreground">{c.learners} enrolled</span>
              </div>
              <button className="btn-primary mt-4 w-full text-xs"><Play className="h-3.5 w-3.5"/>Start course</button>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="label-tiny mb-3">AI Tools for Government</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {tools.map((t, i) => (
            <div key={i} className="rounded-xl border border-border bg-card p-5">
              <div className="h-10 w-10 rounded-lg bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))] grid place-items-center"><t.icon className="h-5 w-5"/></div>
              <div className="mt-3 font-heading font-semibold text-sm">{t.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{t.desc}</div>
              <button className="btn-outline mt-4 text-xs w-full">Launch tool</button>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="label-tiny mb-3">Prompt Library</div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {prompts.map(p => (
            <div key={p.id} className="rounded-xl border border-border bg-card p-5">
              <div className="flex items-start justify-between gap-2">
                <div className="font-heading font-semibold">{p.title}</div>
                <button onClick={()=>navigator.clipboard.writeText(p.prompt)} className="btn-outline text-xs"><Copy className="h-3.5 w-3.5"/>Copy</button>
              </div>
              <div className="mt-2 text-sm text-muted-foreground italic">&ldquo;{p.prompt}&rdquo;</div>
              <div className="mt-3 flex gap-1.5">
                {p.tags.map(t=>(<span key={t} className="stat-pill bg-muted text-muted-foreground text-[10px]">#{t}</span>))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
